<template>
  <div>
    <div class="zone-edit" @keyup.tab="apply">
      <NormalEditor key="ned_2" ref="editor3" :content="r" func="updateR" />
      <b-container>
        <b-row>
          <b-col lg="12" sm="12" style="text-align: center">
            <b-button variant="primary" class="btn100" size="sm" @click="apply"
              >서답형</b-button
            >
            <b-button variant="primary" class="btn100" size="sm" @click="apply2"
              >교정형</b-button
            >
            <b-button variant="primary" class="btn100" size="sm" @click="apply3"
              >선택형</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="zone-view">
      <component v-bind:is="render"></component>

      <div style="text-align: center">
        <b-button variant="success" size="sm" @click="qa">응시</b-button>
      </div>
    </div>
    <div class="zone-result">
      <div class="header">결과:</div>
      <div>{{ ret1 }}</div>
      <div>{{ ret2 }}</div>
      <div>{{ ret3 }}</div>
      <div>{{ ret4 }}</div>
      <hr />
      <div class="result">
        <span class="word">After the laundry is dry</span>
        <span class="word">a worker passes</span>
        <span class="word">the shirts under</span>
      </div>
    </div>
  </div>
</template>

<script>
import NormalEditor from "@/components/NormalEditor";
import XInput from "@/components/XInput";
import XButton from "@/components/XButton";
import XPickButton from "@/components/XPickButton";
export default {
  data() {
    return {
      r: "Hello {10}",
      render: "",
      ret1: "",
      ret2: "",
      ret3: "",
      ret4: "",
      bind1: "XInput",
      imsi: "",
    };
  },
  components: { NormalEditor, XInput, XButton },
  computed: {
    x1() {
      return {
        components: { XInput },
        template: `<div><XInput></XInput/></div>`,
      };
    },
  },
  methods: {
    apply() {
      let plain = this.$store.state.r;
      let k = plain.match(/({.+?})/gm);
      let idx = 1;
      let k2 = plain.replace(/({.+?})/gm, function (b) {
        return `<XInput k="${idx++}"></XInput/>`;
      });

      this.ret = k;
      this.render = {
        components: { XInput },
        template: `<div>${k2}</div>`,
      };
    },
    apply2() {
      let plain = this.$store.state.r;
      let k = plain.match(/({\d+})/gi);
      let idx = 1;

      // plain = plain.replace(/①|②|③|④|⑤/gm, function (b) {
      //   return "<br/>" + b;
      // });
      // console.log(plain);

      let k2 = plain.replace(/({.+?})/gi, function (b) {
        let b1 = b.replace(/{|}/gi, "");
        return `<XButton k="${idx++}" w="${b1}"></XButton/>`;
      });

      this.ret1 = k;

      this.render = {
        components: { XButton },
        template: `<div>${k2}</div>`,
      };
    },
    apply3() {
      let plain = this.$store.state.r;

      let idx = 1;
      // let k = plain.match(/({.+?\|.+?})/);
      // let k2 = plain.replace(/({.+?\|.+?})/gm, function (b) {
      //   let b1 = b.replace(/{|}/gi, "");
      //   return `<XPickButton key="${idx}" k="${idx++}" w="${b1}"></XPickButton/>`;
      // });

      let k = plain.match(/({.+?\|.+?})/);
      let k2 = plain.replace(/({.+?})/gm, function (b) {
        let b1 = b.replace(/{|}/gi, "");
        return `<XPickButton key="${idx}" k="${idx++}" w="${b1}"></XPickButton/>`;
      });

      this.ret1 = k;

      this.render = {
        components: { XPickButton },
        template: `<span>${k2}</span>`,
      };
    },
    qa() {
      console.log(this);
      this.ret1 = this.$store.state["1_ans"];
      this.ret2 = this.$store.state["2_ans"];
      this.ret3 = this.$store.state["3_ans"];
      this.ret4 = this.$store.state["4_ans"];
    },
  },
};
</script>


<style lang="scss">
.zone-edit {
  border: 5px solid orangered;
  height: 33vh;
}
.zone-view {
  border: 5px solid orange;
  height: 33vh;
  padding: 50px;
  p {
    margin-bottom: 2rem;
  }
}
.zone-result {
  border: 5px solid darkcyan;
  height: 33vh;
  padding: 50px;
}
.btn100 {
  margin-right: 5px;
}

.result {
  .word {
    background-color: cyan;
    margin: 4px;
  }
}
</style>